export default __webpack_public_path__ + "static/color-application-dark-a6ba4068da571d1056b65a9261f1bb8285f0408e563bbcea22fb7ba6c261ab50.png";